module.exports = "pegasus/assets/graycircle-linkedin.gif";